
(function() {
  var result = { translations: { "fr": { "i18n": { "duration": { "seconds": "{{ seconds }}\xA0s", "minutes": "{{ minutes }}\xA0min", "hours": "{{ hours }}\xA0h", "hoursAndMinutes": "{{ hours }}\xA0h {{ minutes }}\xA0min", "days": "{{ days }}\xA0jours", "shortForm": { "seconds": "{{ seconds }}\xA0s", "minutes": "{{ minutes }}\xA0min", "hours": "{{ hours }}\xA0h", "days": "{{ days }}\xA0j", "hoursAndMinutes": "{{ hours }}\xA0h {{ minutes }}\xA0min" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": " {{amountNumberValue}}\xA0{{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "fr": "static-7.1334"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1334",
    "ar-eg": "static-7.1334",
    "bg": "static-7.1334",
    "bn": "static-7.1334",
    "ca-es": "static-7.1334",
    "cs": "static-7.1334",
    "da": "static-7.1334",
    "de": "static-7.1334",
    "el": "static-7.1334",
    "en-gb": "static-7.1334",
    "en": "static-7.1334",
    "es-mx": "static-7.1334",
    "es": "static-7.1334",
    "et": "static-7.1334",
    "fi": "static-7.1334",
    "fr-ca": "static-7.1334",
    "fr": "static-7.1334",
    "he-il": "static-7.1334",
    "hi": "static-7.1334",
    "hr": "static-7.1334",
    "hu": "static-7.1334",
    "id": "static-7.1334",
    "it": "static-7.1334",
    "ja": "static-7.1334",
    "ko": "static-7.1334",
    "lt": "static-7.1334",
    "ms": "static-7.1334",
    "nl": "static-7.1334",
    "no": "static-7.1334",
    "pl": "static-7.1334",
    "pt-br": "static-7.1334",
    "pt-pt": "static-7.1334",
    "ro": "static-7.1334",
    "ru": "static-7.1334",
    "sk": "static-7.1334",
    "sl": "static-7.1334",
    "sv": "static-7.1334",
    "th": "static-7.1334",
    "tl": "static-7.1334",
    "tr": "static-7.1334",
    "uk": "static-7.1334",
    "vi": "static-7.1334",
    "x-pseudo": "static-7.1334",
    "zh-cn": "static-7.1334",
    "zh-hk": "static-7.1334",
    "zh-tw": "static-7.1334"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fr', {version: 'static-7.1334'}); }
})();


